import ControlBase from '../fabric/ControlBase';
import { fabric } from 'fabric';

const OFFSET = 16;
const HEIGHT = 34;
const WIDTH = 14;
const RADIUS = 3;
const INNER_LINE_OFFSET = 1.4;
const INNER_LINE_LENGTH = 12;
const INNER_LINE_WIDTH = 1;

class TimelineDateControl extends ControlBase {
  // Name of the action the control is used for.
  // The timeline control uses listeners around the 'scale' event so we hook
  // into that.
  actionName = 'scale';

  constructor(options) {
    super(options);
    this.offsetX = OFFSET * Math.sign(this.x);
    this.sizeX = WIDTH;
    this.sizeY = HEIGHT;
    this.actionHandler = this.actionHandler.bind(this);
  }

  cursorStyleHandler(eventData, control, fabricObject) {
    let cursorStyle = 'grab';
    if (this.isActive(fabricObject) && eventData.type !== 'mouseup') {
      cursorStyle = 'grabbing';
    }

    return cursorStyle;
  }

  actionHandler(eventData, transform, x, y) {
    const { target } = transform;
    return target.shape?.changeDateRange(() => {
      // Ensure that the transformation is calculated around the
      // actual position of the control and not the border of the element.
      const adjustedOffset =
        this.offsetX -
        (Math.sign(this.x) * (this.sizeX ?? 0)) / target.canvas.getZoom();

      return fabric.controlsUtils.scalingX(
        eventData,
        transform,
        x + adjustedOffset,
        y
      );
    });
  }

  render(
    ctx: CanvasRenderingContext2D,
    left: number,
    top: number,
    styleOverride,
    fabricObject
  ) {
    const x = left - WIDTH / 2;
    const y = top - HEIGHT / 2;
    let shadowColor = 'rgba(0, 0, 0, 0.08)';
    let innerLineColor = '#666666';
    let backgroundColor = '#FFFFFF';

    if (this.isActive(fabricObject)) {
      backgroundColor = '#0073CF';
      innerLineColor = '#FFFFFF';
    } else if (this.isHovered()) {
      shadowColor = 'rgba(0, 115, 207, 0.08)';
      innerLineColor = '#0073CF';
    }
    ctx.save();
    ctx.shadowColor = shadowColor;
    ctx.shadowBlur = 8;
    ctx.fillStyle = backgroundColor;

    ctx.beginPath();
    if (ctx.roundRect) {
      ctx.roundRect(x, y, WIDTH, HEIGHT, RADIUS);
    } else {
      ctx.rect(x, y, WIDTH, HEIGHT);
    }
    ctx.fill();

    ctx.strokeStyle = innerLineColor;
    ctx.lineWidth = INNER_LINE_WIDTH;
    ctx.lineJoin = 'round';

    ctx.beginPath();
    ctx.moveTo(left - INNER_LINE_OFFSET, top - INNER_LINE_LENGTH / 2);
    ctx.lineTo(left - INNER_LINE_OFFSET, top + INNER_LINE_LENGTH / 2);
    ctx.stroke();

    ctx.beginPath();
    ctx.moveTo(left + INNER_LINE_OFFSET, top - INNER_LINE_LENGTH / 2);
    ctx.lineTo(left + INNER_LINE_OFFSET, top + INNER_LINE_LENGTH / 2);
    ctx.stroke();

    ctx.restore();
  }
}

export default TimelineDateControl;
